export function getCookieValue(name: string): string | null {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((c) => c.startsWith(name + '='));
  if (cookie) {
    return cookie.split('=')[1];
  }
  return null; // Return null if the cookie is not found
}
